
import {Component, Vue, Watch} from 'vue-property-decorator'
import axios from '@/axios'
import OrderInfo from '@/model/modules/OrderInfo'
import CourierInfo from '@/model/modules/CourierInfo'
import FromUserInfo from '@/model/modules/FromUserInfo'
import FromUserService from '@/service/modules/FromUserService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import CourierService from '@/service/modules/CourierService'

@Component
export default class PostcodeDataEditor extends Vue {
  showState: boolean = false
  dataLoadingState: boolean = false
  isFreightTrial: boolean = false
  orderList: OrderInfo[] = []
  saveSuccessCallback: any

  headerDefine: any = [
    {text: '订单号', value: 'orderNo'},
    {text: '发件信息', value: 'fromUserDto.name'},
    {text: '收件人', value: 'receiveName'},
    {text: '预算总金额', value: 'totalPrice'},
    {text: '物流方式', value: 'courierDto.courierName'}
  ]

  courierId: number = 0
  fromUser: number = 0
  courierOptionsList: CourierInfo[] = []
  fromUserOptionsList: FromUserInfo[] = []

  uploadPanelShowState: boolean = false
  uploadingState: boolean = false
  // @ts-ignore
  uploadUrl: string = window.$HOST + '/order/import'
  uploadHeaders: any = axios.defaults.headers

  mounted() {
    FromUserService.listWithUser({}, 0, 999999)
      .then((result: BasePageableInfo<FromUserInfo>) => {
        this.fromUserOptionsList = result.dataList
        if (this.fromUserOptionsList.length > 0) {
          this.fromUser = this.fromUserOptionsList[0].id
        }
      })
    CourierService.listWithUser({}, 0, 999999)
      .then((result: BasePageableInfo<CourierInfo>) => {
        this.courierOptionsList = result.dataList
        if (this.courierOptionsList.length > 0) {
          this.courierId = this.courierOptionsList[0].id
        }
      })
  }

  showUploader(isFreightTrial: boolean, saveSuccessCallback: any) {
    this.uploadPanelShowState = true
    this.isFreightTrial = isFreightTrial
    this.refreshUploadUrl()
    this.saveSuccessCallback = saveSuccessCallback
  }

  @Watch('courierId')
  onCourierChanged() {
    this.refreshUploadUrl()
  }

  @Watch('fromUser')
  onFromUserChanged() {
    this.refreshUploadUrl()
  }

  refreshUploadUrl() {
    // @ts-ignore
    this.uploadUrl = window.$HOST + '/order/import?channel=' + this.courierId + '&fromUser=' + this.fromUser + '&save=' + (!this.isFreightTrial)
  }

  beforeUpload() {
    this.uploadingState = true
  }

  uploadSuccess(response: any) {
    this.uploadingState = false
    // @ts-ignore
    this.$refs.uploader.clearFiles()
    this.uploadPanelShowState = false
    if (this.isFreightTrial) {
      this.orderList = response.body
      this.showState = true
    } else {
      this.saveSuccessCallback()
      if (response.body.length > 0) {
        this.$alert('<div style="max-height: 300px; overflow:scroll;"> 1订单Excel上传完毕，服务器返回了如下提示：<br>\n' + response.body.join('<br>') + '</div>', '订单Excel上传', {
          confirmButtonText: '我知道了',
          dangerouslyUseHTMLString: true
        })
      }
      this.$notify({
        title: 'Excel上传结束',
        message: '上传成功',
        type: 'success'
      })
    }
  }

  uploadFailed(e: Error) {
    this.uploadingState = false
    this.$alert('订单Excel上传完毕，服务器返回了如下错误：<br>' + JSON.parse(e.message).errMsg, '订单Excel上传', {
      confirmButtonText: '我知道了',
      dangerouslyUseHTMLString: true
    })
  }
}
